"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavedUserIdColamCtn = void 0;
// Default implmentation for colam_ctn cookie based
// saved user id.   Involves letting tguard know
// to save the id which will set the cookie.
var SavedUserIdColamCtn = /** @class */ (function () {
    function SavedUserIdColamCtn() {
        // Send saveUserId parameter to authenticate
        // and login to update colam cookie
        this.sendToApi = true;
        // flag for cookies during unit test.
        this.unitTest = false;
    }
    SavedUserIdColamCtn.prototype.getSavedUserIds = function () {
        var result = this.decodeCookie();
        if (result.hist === null || result.hist.length === 0 || result.hist[0] === '') {
            return [];
        }
        return result.hist;
    };
    // We don't have to do anything for adding,
    // handled in tguard post
    // tslint:disable-next-line:no-empty
    SavedUserIdColamCtn.prototype.addSavedUserId = function (id) { };
    SavedUserIdColamCtn.prototype.deleteSavedUserId = function (id) {
        console.log('deleteSaveUserId');
        var colamCtn = this.decodeCookie();
        if (colamCtn.hist.indexOf(id) !== -1) {
            var i = colamCtn.hist.indexOf(id);
            colamCtn.hist.splice(i, 1);
            colamCtn.lgntypes.splice(i, 1);
            document.cookie = this.createCookieValue(colamCtn);
        }
    };
    SavedUserIdColamCtn.prototype.createCookieValue = function (colamCtn) {
        var value = [];
        var haveValues = (colamCtn.uid !== '');
        if (haveValues) {
            value.push("uid=" + colamCtn.uid);
            value.push("lgn=" + colamCtn.lgn);
            value.push("rme=" + colamCtn.rme);
        }
        // Always push language
        value.push("l=" + colamCtn.l);
        if (haveValues) {
            value.push("r=" + colamCtn.r);
            value.push("hist=" + colamCtn.hist.join(','));
            value.push("lgntypes=" + colamCtn.lgntypes.join(','));
        }
        var setCookieValue = 'colam_ctn=' + encodeURIComponent(value.join(';'));
        // When unit testing the .att.com
        // causes this to not actually set
        // so only appending if this is flag is
        // false which is the default
        if (!this.unitTest) {
            setCookieValue = setCookieValue + '; path=/; domain=.att.com;';
        }
        return setCookieValue;
    };
    SavedUserIdColamCtn.prototype.decodeCookie = function () {
        var result = {
            hist: [],
            l: '',
            lgn: '',
            lgntypes: [],
            r: '',
            rme: '',
            uid: '',
        };
        console.log('colam_ctn 1', document.cookie);
        if (document.cookie.indexOf('colam_ctn') === -1) {
            return result;
        }
        console.log('colam_ctn 2', document.cookie.indexOf('colam_ctn'));
        try {
            var st = document.cookie.indexOf('colam_ctn');
            var valueStart = document.cookie.indexOf('=', st) + 1;
            var valueEnd = document.cookie.indexOf(';', valueStart) > -1 ?
                document.cookie.indexOf(';', valueStart) : document.cookie.length;
            var cookieValue = decodeURIComponent(document.cookie.substring(valueStart, valueEnd));
            var sections = cookieValue.split(';');
            for (var _i = 0, sections_1 = sections; _i < sections_1.length; _i++) {
                var val = sections_1[_i];
                var _a = val.split('='), name_1 = _a[0], value = _a[1];
                if (name_1 === 'lgntypes' || name_1 === 'hist') {
                    var arr = value.split(',');
                    result[name_1] = arr;
                }
                else {
                    result[name_1] = value;
                }
            }
        }
        catch (e) {
            console.error(e);
        }
        // console.log( `result:: `, result );
        return result;
    };
    return SavedUserIdColamCtn;
}());
exports.SavedUserIdColamCtn = SavedUserIdColamCtn;
//# sourceMappingURL=SavedUserIdHandler.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/SaveUserID/SavedUserIdHandler.js
// module id = 585
// module chunks = 8